export { default as alert } from '@handlebars/alert.hbs';
export { default as commonShareLayer } from '@handlebars/common_share_layer.hbs';
export { default as commonSharePcBtns } from '@handlebars/common-share-pc-btns.hbs';
export { default as homeInfo } from '@handlebars/home-info.hbs';
export { default as homeEmpty } from '@handlebars/mobile/home-empty.hbs';
export { default as mwIllegalfilmingReportPopupLayer } from '@handlebars/mw-illegal-filming-report-popup-layer.hbs';
export { default as mwIllegalFilmingReportPopuplayer } from '@handlebars/mw-illegal-filming-report-popup-layer.hbs';
export { default as mwReportLayer } from '@handlebars/mw-report-layer.hbs';
